import React, { FC, useState } from 'react';
import { Box, TextField } from '@material-ui/core';

import { translate } from '../../../../utils/helpers';
import { digitsRegexp, multiLangCharRegexp } from '../../../../utils/regexps';
import { CustomButton } from '../../../../components/UI/CustomButton';
import useStyles from './styles';

interface SubscriptionFormProps {
  maxUsers: number;
  minUsers: number;
  handleCheckout: (companyName?: string, subscriptionsAmount?: string) => void;
}

const SubscriptionForm: FC<SubscriptionFormProps> = ({ maxUsers, minUsers, handleCheckout }) => {
  const classes = useStyles();

  const [name, setName] = useState<string>('');
  const [amount, setAmount] = useState<string>('');
  const [nameErr, setNameErr] = useState<string>('');
  const [amountErr, setAmountErr] = useState<string>('');

  const validateForm = () => {
    let isValid = true;
    if (!name.trim()) {
      setNameErr(translate('error.fieldRequired'));
      isValid = false;
    }
    if (!!name.trim() && !multiLangCharRegexp.test(name.trim())) {
      setNameErr(translate('error.incorrectCompanyName'));
      isValid = false;
    }
    if (!amount) {
      setAmountErr(translate('error.fieldRequired'));
      isValid = false;
    }
    if (parseInt(amount) < minUsers) {
      setAmountErr(translate('error.minUsersErr', { minUsers }));
      isValid = false;
    }
    if (parseInt(amount) > maxUsers) {
      setAmountErr(translate('error.maxUsersErr', { maxUsers }));
      isValid = false;
    }
    return isValid;
  };

  const handleClick = () => {
    if (validateForm()) {
      handleCheckout(name, amount);
    }
  };

  return (
    <Box className={classes.form}>
      <Box className={classes.formFieldWrap}>
        <TextField
          name="companyName"
          variant="outlined"
          label={translate('page.subscription.companyName')}
          className={classes.formField}
          value={name}
          onChange={(e) => {
            if (e.target.value) {
              setNameErr('');
            }
            setName(e.target.value);
          }}
          error={!!nameErr}
          helperText={nameErr}
        />
      </Box>
      <Box className={classes.formFieldWrap}>
        <TextField
          name="numberOfLearners"
          variant="outlined"
          label={translate('page.subscription.numberOfLearners')}
          className={classes.formField}
          value={amount}
          onChange={(e) => {
            if (e.target.value) {
              setAmountErr('');
            }
            setAmount(e.target.value.replace(digitsRegexp, ''));
          }}
          error={!!amountErr}
          helperText={amountErr}
        />
      </Box>
      <CustomButton btnClass={'submit-btn'} onClick={handleClick}>
        {translate('button.subscribe')}
      </CustomButton>
    </Box>
  );
};

export default SubscriptionForm;
